<template lang="pug">
.item
  v-row
    v-col.d-flex.align-center
      v-spacer
      template()
        g-btn(icon, @click="$emit('duplicate', instance)")
          v-icon.primary--text mdi-file-outline
        g-btn(icon, @click="$emit('close', instance)")
          v-icon.primary--text mdi-close
  v-row
    v-col(cols="3", sm="3")
      v-select(
        :label="$t('QuoteItem.serviceItem')",
        :value="instance['serviceItem']"
        @input="$store.commit(setInstancePathAction, { path: path + '.serviceItem', value: $event })"
        :items="serviceItems",
        item-text='name',
        item-value='name',
        :error-messages="errors[`quoteItems[${elementIndex}].serviceItem`]",
      )
    v-col(cols="1", sm="1")
      v-text-field(
        :label="$t('QuoteItem.quantity')",
        :value="quantity"
        @input="setQuantity($event)"
        type="number",
        min="0"
        :rules="[v => (v >= 0) || $t('QuoteItem.quantityRule')]"
        :error-messages="errors[`quoteItems[${elementIndex}].quantity`]"
      )
    v-col(cols="2", sm="2")
      v-select(
        :label="$t('QuoteItem.handlingUnit')",
        :value="instance['handlingUnit']"
        @input="$store.commit(setInstancePathAction, { path: path + '.handlingUnit', value: $event })"
        :items="handlingUnits",
        item-text='name',
        item-value='name',
        :error-messages="errors[`quoteItems[${elementIndex}].handlingUnit`]",
      )
    v-col(cols="1", sm="1")
      v-text-field(
        :label="$t('QuoteItem.buy')",
        :value="buy"
        @input="setBuy($event)"
        type="number",
        min="0"
        :rules="[v => (v >= 0) || $t('QuoteItem.rateRule')]"
        :error-messages="errors[`quoteItems[${elementIndex}].buy`]"
      )
    v-col(cols="1", sm="1")
      v-text-field(
        :label="$t('QuoteItem.sell')",
        :value="sell"
        type="number",
        disabled,
        min="0"
        :error-messages="errors[`quoteItems[${elementIndex}].sell`]"
      )
    v-col(cols="1", sm="1")
      v-text-field(
        :label="$t('QuoteItem.markup')",
        :value="markup"
        @input="setMarkup($event)"
        type="number",
        min="0"
        :rules="[v => (v >= 0) || $t('QuoteItem.markupRule')]"
        :error-messages="errors[`quoteItems[${elementIndex}].markup`]"
      )
    v-col(cols="1", sm="1")
      v-text-field(
        :label="$t('QuoteItem.subtotal')",
        :value="subtotalCalculated"
        type="number",
        disabled
        min="0"
        :error-messages="errors[`quoteItems[${elementIndex}].subtotal`]"
      )
    v-col(cols="2", sm="2")
      v-text-field(
        :label="$t('QuoteItem.subtotalSell')",
        :value="subtotalSell"
        type="number",
        disabled,
        min="0"
        :error-messages="errors[`quoteItems[${elementIndex}].subtotalSell`]"
      )
    v-col(cols="4", sm="4")
      v-text-field(
        :label="$t('QuoteItem.remarks')",
        :value="instance['remarks']"
        @input="$store.commit(setInstancePathAction, { path: path + '.remarks', value: $event })"
        :error-messages="errors[`quoteItems[${elementIndex}].remarks`]"
      )
    v-col(cols="2", sm="2")
      v-text-field(
        :label="$t('QuoteItem.uiSequence')",
        :value="instance['uiSequence']"
        type="number",
        @input="$store.commit(setInstancePathAction, { path: path + '.uiSequence', value: $event })"
        :error-messages="errors[`quoteItems[${elementIndex}].uiSequence`]"
      )
</template>

<style lang="scss" scoped>
.item {
  ::v-deep i {
    color: var(--v-primary-base);
  }
}
</style>

<script>
import axios from 'axios';
import EntityMixin from '@/mixins';

export default {
  mixins: [EntityMixin],
  props: {
    selector: {
      type: Boolean,
      default: true,
    },
    entity: {
      type: Object,
      default: () => ({}),
    },
    path: {
      type: String,
      default: null
    },
    parentPath: {
      type: String,
      default: null
    },
    parent: {
      type: Object,
      default: () => ({})
    },
    elementIndex: {
      type: Number,
      default: 0
    },
    serviceItems: {
      type: Array,
      default: () => ([])
    },
    handlingUnits: {
      type: Array,
      default: () => ([])
    },
  },
  data: () => ({
    quantity: 0,
    buy: 0,
    markup: 0,
  }),
  watch: {
    subtotalCalculated: {
      deep:false,
      handler(n, o) {
        if (n != null)
          this.$store.commit(this.setInstancePathAction, { path: this.path + '.subtotal', value: Number(n.toFixed(2)) })
        else
          this.$store.commit(this.setInstancePathAction, { path: this.path + '.subtotal', value: 0 })
      }
    },
    subtotalSell: {
      deep:false,
      handler(n, o) {
        if (n != null)
          this.$store.commit(this.setInstancePathAction, { path: this.path + '.subtotalSell', value: Number(n.toFixed(2)) })
        else
          this.$store.commit(this.setInstancePathAction, { path: this.path + '.subtotalSell', value: 0 })
      }
    },
  },
  methods: {
    setBuy(value) {
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.buy', value: Number(value) });
      this.buy = Number(value);
    },
    setQuantity(value) {
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.quantity', value: Number(value) });
      this.quantity = Number(value);
    },
    setMarkup(value) {
      this.$store.commit(this.setInstancePathAction, { path: this.path + '.markup', value: Number(value) });
      this.markup = Number(value);
    },
  },
  computed: {
    errors() {
      return this.$store.state.errors;
    },
    subtotalCalculated(){
      return Number((this.buy * this.quantity).toFixed(2));
    },
    sell(){
      return Number((this.buy * (1 + (this.markup / 100))).toFixed(2));
    },
    subtotalSell() {
      return Number((this.sell * this.quantity).toFixed(2));
    },
  },
  async created() {
    this.quantity = this.instance.quantity || 0;
    this.buy = this.instance.buy || 0;
    this.markup = this.instance.markup || 0;
  },
}
</script>
